import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/ticket.svg',
})
export class TicketComponent{}
